
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/draw",
      function () {
        return require("private-next-pages/casino/draw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/draw"])
      });
    }
  